// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"f65d0569","675":"f412fd0b","787":"26eaa0f9"}[chunkId] + ".chunk.js";
};